import {Badge, Menu, type MenuProps} from 'antd'
import React from 'react'
import {Link} from 'react-router-dom'
import classNames from 'classnames'
import {observer} from 'mobx-react'

import {MenuDataItem} from '@/types'
import {isAbsoluteUrl} from '@/utils'
import {Icon} from '@/components/dumb/Icon'
import {SiderMenuProps} from './props'
import styles from './styles.scss'

export const SiderMenu: React.FC<SiderMenuProps> = observer((props) => {
    const {menuItems, selectedKeys, openKeys, onSelect, onOpenChange, className} = props

    const renderMenuItems = (items: MenuDataItem[]): MenuProps['items'] => {
        return items.map((item) => {
            if (item.type === 'group') {
                return {
                    key: item.key ?? `group:${String(item.title)}`,
                    type: 'group',
                    label: item.title,
                    children: item.children?.length ? renderMenuItems(item.children) : []
                }
            }

            const isLeaf = !!item.path && (!item.children || item.children.length === 0)

            return {
                key: item.path ?? item.key ?? String(item.title),
                icon: item.icon,
                className: item.menuItemClassName,
                label: isLeaf ? (
                    <Link
                        className={item.className}
                        to={item.path!}
                        target={isAbsoluteUrl(item.path!) ? '_blank' : undefined}
                    >
                        {item.title}
                        {item.badge && (
                            <Badge.Ribbon text={item.badge} color='var(--color-secondary)' />
                        )}
                    </Link>
                ) : (
                    <div className={item.className}>
                        {item.title}
                        {item.badge && (
                            <Badge.Ribbon text={item.badge} color='var(--color-secondary)' />
                        )}
                    </div>
                ),
                children: item.children?.length ? renderMenuItems(item.children) : undefined
            }
        })
    }

    return (
        <Menu
            className={classNames(styles.menu, className)}
            selectedKeys={selectedKeys}
            openKeys={openKeys}
            expandIcon={ExpandIcon}
            onSelect={onSelect}
            onOpenChange={onOpenChange}
            inlineIndent={0}
            mode={'inline'}
            items={renderMenuItems(menuItems)}
        />
    )
})

const ExpandIcon: React.FC<{isOpen: boolean}> = ({isOpen}) => {
    return isOpen ? <Icon type={'up_outlined'} /> : <Icon type={'down_outlined'} />
}
